'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var URL = exports.URL = 'URL';
var QUERY_PARAM = exports.QUERY_PARAM = 'QUERY_PARAM';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/TargetingRuleSourceTypes.js
// module id = 910
// module chunks = 2 3